import { mode } from '@/config';
import * as OM from '@/model';
import { Options, Vue } from 'vue-class-component';
import { createStore, StoreOptions } from 'vuex';
import { StorageServices } from '@/services/StorageServices';
import { RouteLocationNormalizedLoadedGeneric } from 'vue-router';
import { getQueryParams } from '@/utils';

let storeState = {
    showSpinner: 0,
    isServedMode: () => {
        return mode == 'served';
    },
    isTestMode: () => {
        return mode == 'test';
    },
    getParameters: {
        apiClaim: '',
        customerName: '',
        customerWebId: '',
        groupId: '',
        language: '',
        parameterCacheId: '',
        timestamp: '',
        estateId: '',
        businessUnit: '',
        userId: '',
        signature: '',
    },
    pageTitle: "",
    routeBuster: false,
    beforeNavCbs: <((to: RouteLocationNormalizedLoadedGeneric, from: RouteLocationNormalizedLoadedGeneric) => void)[]>[],
    afterNavCbs: <((to: RouteLocationNormalizedLoadedGeneric, from: RouteLocationNormalizedLoadedGeneric) => void)[]>[],
    formErrors: <{ [key: string]: boolean }>{},
    copyToClipboard: copyToClipboard,
}


let vuestore: StoreOptions<typeof storeState> = {
    state: storeState,
	mutations: {
		showSpinner(state){
            state.showSpinner++;
		},
		hideSpinner(state){
            state.showSpinner--;
            if(state.showSpinner < 0){
                state.showSpinner = 0;
            }
        }
	},
}


const GET_PARAMETER_APICLAIM = 'apiClaim';
const GET_PARAMETER_CUSTOMERNAME = 'customerName';
const GET_PARAMETER_CUSTOMERWEBID = 'customerWebId';
const GET_PARAMETER_GROUPID = 'groupId';
const GET_PARAMETER_LANGUAGE = 'language';
const GET_PARAMETER_PARAMETERCACHEID = 'parameterCacheId';
const GET_PARAMETER_TIMESTAMP = 'timestamp';
const GET_PARAMETER_ESTATEID = 'estateId';
const GET_PARAMETER_BUSINESSUNIT = 'businessUnit';
const GET_PARAMETER_USERID = 'userId';
const GET_PARAMETER_SIGNATURE = 'signature';

storeState.getParameters.apiClaim = getQueryParams()[GET_PARAMETER_APICLAIM];
storeState.getParameters.customerName = getQueryParams()[GET_PARAMETER_CUSTOMERNAME];
storeState.getParameters.customerWebId = getQueryParams()[GET_PARAMETER_CUSTOMERWEBID];
storeState.getParameters.groupId = getQueryParams()[GET_PARAMETER_GROUPID];
storeState.getParameters.language = getQueryParams()[GET_PARAMETER_LANGUAGE];
storeState.getParameters.parameterCacheId = getQueryParams()[GET_PARAMETER_PARAMETERCACHEID];
storeState.getParameters.timestamp = getQueryParams()[GET_PARAMETER_TIMESTAMP];
storeState.getParameters.estateId = getQueryParams()[GET_PARAMETER_ESTATEID];
storeState.getParameters.businessUnit = getQueryParams()[GET_PARAMETER_BUSINESSUNIT];
storeState.getParameters.userId = getQueryParams()[GET_PARAMETER_USERID];
storeState.getParameters.signature = getQueryParams()[GET_PARAMETER_SIGNATURE];

let store = createStore(vuestore);

export default store;


function copyToClipboard(text, clickEv: MouseEvent = null) {
    var dummy = document.createElement("textarea");
    // to avoid breaking orgain page when copying more words
    // cant copy when adding below this code
    // dummy.style.display = 'none'
    document.body.appendChild(dummy);
    //Be careful if you use texarea. setAttribute('value', value), which works with "input" does not work with "textarea". – Eduard
    dummy.value = text;
    dummy.select();
    document.execCommand("copy");
    document.body.removeChild(dummy);
    
    if(clickEv){
        var popup = document.createElement("div");
        popup.style.position = "fixed";
        popup.style.left = clickEv.clientX + "px";
        popup.style.top = clickEv.clientY + "px";
        popup.style.backgroundColor = "white";
        popup.style.border = "1px solid grey";
        popup.style.pointerEvents = "none";
        popup.style.touchAction = "none";
        // popup.innerHTML = require('@/img/common/check.png'); 
        // "<img src=\"https://upload.wikimedia.org/wikipedia/commons/thumb/e/e9/Check_mark.svg/220px-Check_mark.svg.png\" />";
        document.body.append(popup);
        setTimeout(() => {
            popup.remove();
        }, 400);
    }

}